import {authFetch} from "../../authentication/authFetch";

const API_URL = process.env.REACT_APP_API_URL;

export const upsertPlanner = async (authToken, plannerData) => {
    if (!authToken) throw new Error("Missing auth token");

    const response = await authFetch(`${API_URL}/api/planner`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(plannerData),
    });

    if (!response.ok) {
        throw new Error("Failed to upsert planner");
    }

    return response.json();
};

export const fetchPlannerById = async (authToken, plannerId) => {
    if (!authToken || !plannerId) return null;

    const response = await authFetch(`${API_URL}/api/planner/${plannerId}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        throw new Error("Failed to fetch planner");
    }

    return response.json();
};

export const fetchPlannerOverview = async (authToken, plannerType, planDate) => {
    if (!authToken || !plannerType || typeof planDate !== "number") return { today: null, plans_by_date: {} };

    const query = new URLSearchParams({
        planner_type: plannerType,
        plan_date: String(planDate),
    });

    const response = await authFetch(`${API_URL}/api/planner/overview?${query.toString()}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        throw new Error("Failed to fetch planners");
    }

    const payload = await response.json();
    return {
        today: payload?.today || null,
        plans_by_date: payload?.plans_by_date && typeof payload.plans_by_date === "object"
            ? payload.plans_by_date
            : {},
    };
};
